import type { ReactNode } from 'react'
import { Button } from '../components/ui'

/**
 * Inline confirmation of an admin change: what changes from what to what and
 * when it applies. Every fill setting goes through one before the request
 * (the change lands in the audit log with the previous value).
 */
export function ConfirmChange({ testId, title, children, apply = 'Apply', busy, onApply, onCancel }: {
  testId: string
  title: string
  children?: ReactNode
  apply?: string
  busy?: boolean
  onApply: () => void
  onCancel: () => void
}) {
  return (
    <div role="alertdialog" aria-label={title} data-testid={testId} className="flex flex-col gap-2 rounded-md border border-warn/50 bg-warn/[.07] p-3 text-sm">
      <p className="font-semibold text-warn">{title}</p>
      {children && <div className="space-y-1 text-[13px] text-text-soft">{children}</div>}
      <div className="flex flex-wrap gap-2">
        <Button variant="primary" data-testid={`${testId}-apply`} disabled={busy} onClick={onApply}>
          {busy ? 'Saving…' : apply}
        </Button>
        <Button data-testid={`${testId}-cancel`} disabled={busy} onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  )
}

/** "a → b" with the changed value emphasised. */
export function FromTo({ label, from, to }: { label: string; from: string; to: string }) {
  return (
    <p>
      {label}: <span className="text-muted line-through decoration-1">{from}</span> → <span className="font-medium text-text">{to}</span>
    </p>
  )
}
